<style scoped>
.v-application .error {
  margin-left: 15px;
  margin-right: 15px;
  background-color: #78496a !important;
  border-color: black !important;
}
</style>
<template>
  <v-container class="py-5">
    <v-card>
      <v-card-title>
        Search {{ label }}
        <v-spacer></v-spacer>
        <v-btn
            v-if="label === 'Facility' &&user.role === 'ihris-role-admin' && user.location === ' - Federal Ministry of Health'"
            class="primary mr-6" @click="$router.push('/facility-from-mfr')">
          <v-icon class="mr-2">mdi-code-json</v-icon>
          Import/update data from Mfr Data source
        </v-btn>
        <v-btn v-if="!hideAddButtonFor.includes(profile)" :class="addLink ? addLink.class || 'primary' : 'primary'"
               :to="addLink ? addLink.url : '/resource/add/'+page">
          <v-icon v-if="addLink && addLink.icon">{{ addLink.icon }}</v-icon>
          <v-icon v-else>mdi-database-plus</v-icon>
          Add {{ label }}
        </v-btn>
      </v-card-title>
      <v-card-title>
        <slot></slot>
      </v-card-title>
      <v-card-subtitle
          v-if="error_message"
          class="white--text error"
      >{{ error_message }}
      </v-card-subtitle>
      <v-card-text>
        <v-container>
        </v-container>
        <v-data-table
            :footer-props="{ 'items-per-page-options': [5,10,20,50] }"
            :headers="headers"
            :items="results"
            :loading="loading"
            :options.sync="options"
            :server-items-length="total"
            class="elevation-1"
            item-key="id"
            style="cursor: pointer"
            @click:row="clickIt"
        ></v-data-table>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
export default {
  name: "ihris-search",
  props: ["profile", "fields", "label", "terms", "page", "resource", "add-link"],
  data: function () {
    return {
      debug: "",
      headers: [],
      results: [],
      options: {itemsPerPage: 10, sortBy: ['name']},
      loading: false,
      total: 0,
      prevPage: -1,
      link: [],
      error_message: null,
      update_again: {rerun: false, restart: false},
      user: null,
      hideAddButtonFor:["http://ihris.org/fhir/StructureDefinition/ihris-job-description","http://ihris.org/fhir/StructureDefinition/ihris-auditevent"]
    };
  },
  watch: {
    terms: {
      handler() {
        this.getData(true);
      },
      deep: true
    },
    options: {
      handler() {
        if (this.results.length > 0) {
          this.getData();
        }
        // this.getData();
      },
      deep: true
    },
    results: function () {

    }
  },
  created: function () {
    this.user = this.$store.state.user;
    for (let field of this.fields) {
      this.headers.push({text: field[0], value: field[1]});
    }
  },
  mounted: function () {
    this.getData(true);
  },
  methods: {
    clickIt: function (record) {
      if(this.profile!=="http://ihris.org/fhir/StructureDefinition/ihris-auditevent") {
        this.$router.push({
          name: "resource_view",
          params: {page: this.page, id: record.id}
        });
      }
    },
    checkRerun() {
      if (!this.loading && this.update_again.rerun) {
        this.getData(this.update_again.restart)
        this.update_again = {rerun: false, restart: false}

      }
    },
    getData(restart) {

      if (this.loading) {
        this.update_again.rerun = true
        this.update_again.restart = this.update_again.restart || restart
        return
      }
       this.loading= true;
      this.error_message = null;
      let url = "";
      if (restart) this.options.page = 1;
      if (this.options.page > 1) {
        let newLink = this.link.find((x) => x.relation === "self")?.url;
        const urlParams = newLink.split("?").pop()
        if (this.options.page === this.prevPage - 1) {
          url = `${this.link.find(link => link.relation === "previous").url}&${urlParams}`;
        } else if (this.options.page === this.prevPage + 1) {
          url = `${this.link.find(link => link.relation === "next").url}&${urlParams}`;
        }
        // Should make this smarter to keep the _getpages parameter,
        // but the issue is with tracking permissions on the resource
        url = url.replace(/_getpages=[^&]*&*/, "").replace("/fhir?", "/fhir/" + this.resource + "?")
        url = url.substring(url.indexOf("/fhir/"));

        //some of the hapi instances requires _total=accurate to always be available for them to return total resources
        if (url.indexOf('_total=accurate') === -1) {
          url = url + '&_total=accurate'
        }
      }
      // eslint-disable-next-line no-empty
      if (url === "" && this.page == "practitioner" && Object.keys(this.terms).length === 0) {

      } else if (url === "") {
        let count = this.options.itemsPerPage || 10;
        let sort = (this.page == 'practitioner') ? "&_sort=" + this.options.sortBy.join() : ""
        url =
            "/fhir/" +
            this.resource +
            "?_count=" +
            count + sort +
            "&_total=accurate&_profile=" +
            this.profile;
        let sTerms = Object.keys(this.terms);
        for (let term of sTerms) {
          if (this.profile === 'http://ihris.org/fhir/StructureDefinition/ihris-jurisdiction' && term === 'type') {
            url = url.split('&type=region,woreda,zone')[0].concat(`&type=${this.terms[term]}`)
          } else {
            if (Array.isArray(this.terms[term])) {
              if (this.terms[term].length > 0) {
                url += "&" + term + "=" + this.terms[term].join(',')
              }
            } else if (this.terms[term]) {
              url += "&" + term + "=" + this.terms[term];
            }
          }
        }
        this.debug = url;
      }
      this.prevPage = this.options.page;
      if (this.profile === 'http://ihris.org/fhir/StructureDefinition/ihris-jurisdiction') {
        url = url.concat('&type=region,woreda,zone')
      }
      if (this.profile === 'http://ihris.org/fhir/StructureDefinition/ihris-person-user') {
        url = url.concat('')
      }

      if (this.profile === 'http://ihris.org/fhir/StructureDefinition/ihris-facility') {
        url = url.concat('&_profile=http://ihris.org/fhir/StructureDefinition/ihris-facility')
      }

      if(this.profile === "http://ihris.org/fhir/StructureDefinition/ihris-role"){
        url = url.concat('&_profile=http://ihris.org/fhir/StructureDefinition/ihris-role')
      }

      if(this.profile === "http://ihris.org/fhir/StructureDefinition/ihris-task"){
        url = url.concat('&_profile=http://ihris.org/fhir/StructureDefinition/ihris-task')
      }

      if(this.profile === "http://ihris.org/fhir/StructureDefinition/ihris-manage-position"){
        url = url.concat('&_profile=http://ihris.org/fhir/StructureDefinition/ihris-manage-position')
      }

      if(this.profile === "http://ihris.org/fhir/StructureDefinition/ihris-auditevent"){
        url = url.concat('&_profile=http://ihris.org/fhir/StructureDefinition/ihris-auditevent')
      }

      fetch(url).then(response => {
        response.json().then(async (data) => {
          this.results = [];
          if (data.total > 0) {
            this.link = data.link;
            for (let entry of data.entry) {
              let result = {id: entry.resource.id};
              for (let field of this.fields) {
                let fieldDisplay = this.$fhirpath.evaluate(entry.resource, field[1]);
                result[field[1]] = await this.$fhirutils.lookup(fieldDisplay[0], field[2])
              }
              this.results.push(result);
            }
          }
          this.total = data.total;
          this.loading = false;
          this.checkRerun()
        }).catch(err => {
          if (this.page == 'practitioner') {
            this.error_message = "Select one or more filters, and press enter, to load results.";
          } else {
            this.error_message = "Unable to load results.";
          }
          this.loading = false;
          this.checkRerun()
          console.log(err);
        });
      }).catch(err => {
        this.loading = false;
        this.error_message = "Unable to load results.";
        this.checkRerun()
        console.log(err);
      });
    }

  }
};
</script>
